import React, { useState } from 'react';
import { MoreHorizontal, Edit, Trash2, MessageCircle, Loader2, Plus } from 'lucide-react';
import { IconButton } from './IconButton';
import { Chip } from './Chip';
import './ui.css';
import ActivitySelectorDialog from './ActivitySelectorDialog';

export function AgentCard({ agent, onEdit, onDelete, onUse, onAddToActivity, isCreatingChat = false, canEdit = true }) {
  const [showActivitySelector, setShowActivitySelector] = useState(false);
  const [isAddingToActivity, setIsAddingToActivity] = useState(false);

  const getInitials = (name) => {
    return name ? name.charAt(0).toUpperCase() : 'A';
  };

  const handleAddToActivity = async (activity) => {
    setIsAddingToActivity(true);
    try {
      await onAddToActivity?.(agent, activity);
      setShowActivitySelector(false);
    } catch (error) {
      console.error('添加到活動失敗:', error);
    } finally {
      setIsAddingToActivity(false);
    }
  };

  return (
    <>
      <div className="agent-card">
        <div className="agent-card-header">
          <div className="agent-card-avatar-section">
            <div className="agent-card-avatar">
              <span className="avatar-text">
                {getInitials(agent.name)}
              </span>
            </div>
            <div className="agent-card-info">
              <div className="agent-card-title">{agent.name}</div>
              <div className="agent-card-subtitle">
                {agent.knowledgeBase?.professionalSkills?.substring(0, 50) + '...' || agent.description?.substring(0, 30) + '...'}
              </div>
            </div>
          </div>
          {canEdit && (
            <div className="agent-card-actions">
              <IconButton onClick={(e) => { e.stopPropagation(); onEdit?.(agent); }} title="編輯">
                <Edit size={16} />
              </IconButton>
              <IconButton onClick={(e) => { e.stopPropagation(); onDelete?.(agent.id); }} title="刪除">
                <Trash2 size={16} />
              </IconButton>
            </div>
          )}
        </div>

        <div className="agent-card-content">
          {agent.description && (
            <p className="agent-card-description">{agent.description}</p>
          )}

          <div className="agent-card-tags">
            {agent.category && (
              <Chip variant="category">
                {agent.category}
              </Chip>
            )}
            {agent.tags && agent.tags.split(',').map((tag, index) => (
              <Chip key={index} variant="tag">
                {tag.trim()}
              </Chip>
            ))}
          </div>

          <div className="agent-card-features">
            {agent.knowledgeBase?.professionalSkills && (
              <div className="feature-item">
                <span className="feature-text">{agent.knowledgeBase.professionalSkills.substring(0, 80)}{agent.knowledgeBase.professionalSkills.length > 80 ? '...' : ''}</span>
              </div>
            )}
            {agent.communicationStyle?.interactionMethod && (
              <div className="feature-item">
                <span className="feature-text">{agent.communicationStyle.interactionMethod.substring(0, 50)}...</span>
              </div>
            )}
          </div>
        </div>

        <div className="agent-card-footer">
          <div className="agent-card-meta">
            <span className="creation-date">
              {new Date(agent.createdAt).toLocaleDateString('zh-TW')}
            </span>
            {agent.isPublicTemplate && (
              <Chip variant="public">公開</Chip>
            )}
            {!canEdit && !agent.isPublicTemplate && (
              <Chip variant="shared">其他用戶</Chip>
            )}
          </div>
          
          <div className="agent-card-buttons">
            <button 
              className="use-agent-btn secondary"
              onClick={() => setShowActivitySelector(true)}
              disabled={isAddingToActivity}
            >
              {isAddingToActivity ? (
                <>
                  <Loader2 size={14} className="animate-spin" />
                  添加中...
                </>
              ) : (
                <>
                  <Plus size={14} />
                  加入活動
                </>
              )}
            </button>
            
            <button 
              className="use-agent-btn"
              onClick={() => onUse?.(agent)}
              disabled={isCreatingChat}
            >
              {isCreatingChat ? (
                <>
                  <Loader2 size={14} className="animate-spin" />
                  創建中...
                </>
              ) : (
                <>
                  <MessageCircle size={14} />
                  與夥伴聊天
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      <ActivitySelectorDialog
        open={showActivitySelector}
        onClose={() => setShowActivitySelector(false)}
        onSelectActivity={handleAddToActivity}
        isLoading={isAddingToActivity}
        agentName={agent.name}
        agentId={agent.id}
      />
    </>
  );
} 